<app-health-grid [gridType]="gridType" (searchTermChanged)="onSearchChanged($event)" [title]="title"
                 [total]="total" [totalTitle]="totalTitle">
  <app-devices-health-list [widgetClass]="'grid-widget'" (total)="total = $event"
                           [searchText]="searchTerm">
  </app-devices-health-list>
</app-health-grid>
